module.exports = __webpack_public_path__ + "assets/img/eternia-40.c92c8969.jpg";